/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $on = _ref.$on,
      $update = _ref.$update;
  $on('pageInit', function () {
    if (localStorage.getItem("account-name") == null) {
      localStorage.setItem("account-stock-price", 100);
      $(".stock").hide();
    }

    $(".AccountName").html(localStorage.getItem("account-name"));
    $(".AccountMarketPrice").html(localStorage.getItem("account-stock-price"));
    $(".AccountMarketPriceMinimum").html((localStorage.getItem("account-stock-price") * 0.01).toFixed(2));
    $(".AccountMarketPriceDouble").html((localStorage.getItem("account-stock-price") * 0.01 * 2).toFixed(2));
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">How To Use</div>
    </div>
  </div>
  <div class="page-content control-size">
      <div class="card card-update" style="border-radius: 10px;background-color: #151924;">
        <div class="card-header">
          <div class="row">
            <div class="col-20"><img src="static/images/information.png" style="width: 100%"/></div>
            <div class="col-80">3 Easy Steps</div>
          </div>
        </div>
        <div class="card-content card-content-padding">
          <ol type="1">
            <li><span class="makeitbold">Deposit</span> by lot e.g 0.01 = US$<span class="AccountMarketPriceMinimum"></span>. The deposit is managed by OctaFX.</li>
            <li>RobotFX will <span class="makeitbold">automate</span> the trade over the cloud and notify using Telegram</li>
            <li><span class="makeitbold">Withdraw</span> by lot after a certain period e.g 0.01 = US$<span class="AccountMarketPriceDouble"></span></li>
          </ol>
        </div>
        <div class="card-header">
          <span style="color: gray; font-size: smaller;">Saturday & Sunday the market is closed</span>
        </div>
      </div>

      <div class="card card-update" style="border-radius: 10px;background-color: #151924;">
        <div class="card-header">
          <div class="row">
            <div class="col-20"><img src="static/images/information.png" style="width: 100%"/></div>
            <div class="col-80">Other Info</div>
          </div>
        </div>
        <div class="card-content card-content-padding">
          <table width="100%" style="text-align:center;">
            <tr>
              <td></td><td colspan="3" style="background-color:#154360;text-align: center;">EARNING</td>
            </tr>
            <tr >
              <td></td><td style="background-color:#474b09;">You</td><td style="background-color:#474b09;">Broker</td><td style="background-color:#474b09;">RobotFX</td>
            </tr>
            <tr>
              <td style="text-align:left;">Profit</td><td>70%</td><td>10%</td><td>20%</td>
            </tr>
            <tr class="stock">
              <td></td><td colspan="3" style="background-color:#154360;text-align: center;">STOCK</td>
            </tr>
            <tr class="stock">
              <td style="text-align:left;">Name</td><td colspan="3" class="AccountName"></td>
            </tr>
            <tr class="stock">
              <td style="text-align:left;">Trade</td><td colspan="3">GBPUSD</td>
            </tr>
            <tr class="stock">
              <td style="text-align:left;">Price</td><td colspan="3">1 LOT = US$<span class="AccountMarketPrice"></span></td>
            </tr>
            <tr class="stock">
              <td style="text-align:left;">Min</td><td colspan="3">0.01 LOT = US$<span class="AccountMarketPriceMinimum"></span> </td>
            </tr>
          
          </table>
        </div>
      </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '0946a54548';
export default framework7Component;